import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactSelect from "react-select";

export default function Select({
  label,
  onChange,
  value,
  options,
  name,
  error,
  formErrors,
  placeholder,
}) {
  if (error === undefined && name && formErrors) {
    error = formErrors.find((p) => p.field === name);
  }

  return (
    <div className="flex-1 flex flex-col">
      <label htmlFor={name} className="text-nowrap">{label}</label>
      <ReactSelect
        name={name}
        placeholder={placeholder}
        options={options}
        defaultValue={{ label: value, value }}
        onChange={onChange}
        menuPortalTarget={document.body}
      />
      {error && (
        <span
          className={`
            text-sm flex gap-0.5 items-center pl-0.5
            ${error.level === 'warning' ? 'text-orange-600' : 'text-red-600'}
          `}
        >
          <FontAwesomeIcon
            icon={error.level === 'warning' ? 'triangle-exclamation' : 'circle-exclamation'}
          />
          {error.message}
        </span>
      )}
    </div>
  );
}
